import { FC } from 'react'
import { BitazzaModal } from '../../../../components'
import { NotLinkedFdw } from './NotLinkedFdw'
import { LinkedFdw } from './LinkedFdw'

interface Props {
    isClaimModalOpen: boolean
    onCLoseNftModal: () => void
    freedomWallet: boolean
    rewards?: prizeSeasonStatus[]
}

export const NftClaim: FC<Props> = ({
    isClaimModalOpen,
    onCLoseNftModal,
    freedomWallet,
    rewards,
}) => {
    return (
        <BitazzaModal
            footer={null}
            onCancel={onCLoseNftModal}
            style={{ backgroundColor: 'rgb(27, 30, 30)' }}
            isModalOpen={isClaimModalOpen}
            size={freedomWallet ? '560px' : '620px'}
        >
            {!freedomWallet ? (
                <NotLinkedFdw onConfirmHandler={onCLoseNftModal} />
            ) : (
                <LinkedFdw
                    onConfirmHandler={onCLoseNftModal}
                    rewards={rewards}
                />
            )}
        </BitazzaModal>
    )
}
